<template>
  <main>
    <InputFilter class="pt-10" :pagination="pagination" />

    <section class="filter-area">
      <v-container class="py-0">
        <v-row no-gutters>
          <v-col sm="10" class="mx-auto py-0">
            <v-row justify="space-between" no-gutters>
              <v-col cols="12" sm="2" class="py-0 camp-type">
                <v-autocomplete
                  :items="camps"
                  item-text="name"
                  item-value="id"
                  label="Camp"
                  filled
                  dense
                  :append-icon="filter.camp_id ? 'mdi-close' : ''"
                  @click:append="clearSearchData('camp_id')"
                  v-model="filter.camp_id"
                  @change="filterCamps"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="2" class="py-0 month">
                <v-select
                  :items="months"
                  item-text="num"
                  item-value="num"
                  label="Month"
                  filled
                  :append-icon="filter.month ? 'mdi-close' : ''"
                  @click:append="clearSearchData('month')"
                  dense
                  v-model="filter.month"
                  @change="filterMonths"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="2" class="py-0 year">
                <v-select
                  :items="yearsList"
                  item-text="year"
                  item-value="year"
                  label="Year"
                  filled
                  dense
                  :append-icon="filter.year ? 'mdi-close' : ''"
                  @click:append="clearSearchData('year')"
                  v-model="filter.year"
                  @change="filterYears"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="2" class="py-0 location">
                <v-select
                  :items="statuses"
                  item-text="name"
                  item-value="abbreviation"
                  label="Status"
                  filled
                  dense
                  :append-icon="filter.status ? 'mdi-close' : ''"
                  @click:append="clearSearchData('status')"
                  v-model="filter.status"
                  @change="filterStatuses"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="2" class="py-0 gender">
                <v-text-field
                  label="Wellspring ID"
                  filled
                  dense
                  :append-icon="filter.wellspringid ? 'mdi-close' : ''"
                  @click:append="clearSearchData('wellspringid')"
                  v-model="filter.wellspringid"
                  @change="filterId"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <!-- <v-col cols="12" sm="2">
            <v-btn to="/bookings" text color="red" width="100%" height="40px"
              >Reset</v-btn
            >
          </v-col> -->
        </v-row>
      </v-container>
    </section>
    <v-container class="booking-table">
      <v-toolbar flat class="main-header">
        <v-toolbar-title class="main-header__title">
          <h1>Bookings</h1>
          <!-- {{ paymentBool }} -->
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items class="main-header__contents">
          <v-btn
            class="button btn-height--1 my-auto mx-1 radius-12"
            color="success"
            rounded
            @click="depositDialog = true"
            :disabled="selected.length == 0 || DepositBoolean"
          >
            <span class="mx-2">Pay Deposit</span>
          </v-btn>
          <v-btn
            class="button btn-height--1 my-auto mx-1 radius-12"
            color="success"
            rounded
            @click="payOrders"
            :disabled="selected.length == 0 || paymentBoolean"
          >
            <v-icon>mdi-currency-usd-circle</v-icon>
            <span class="mx-2">Pay</span>
          </v-btn>
          <v-btn
            href="https://wellspringegypt.com/operation/login"
            target="_blank"
            color="primary"
            class="px-5 btn-height--1 ml-3 my-auto radius-12"
            rounded
            >Book Now</v-btn
          >
        </v-toolbar-items>
      </v-toolbar>
      <hr class="my-6" />
      <v-btn rounded large color="white" to="/reciepts" class="mb-6 px-10 shade"
        ><strong>Receipts</strong></v-btn
      >
      <v-data-table
        v-model="selected"
        show-select
        :single-select="singleSelect"
        hide-default-footer
        :headers="ordersTableHeaders"
        :items="orders"
        :mobile-breakpoint="zero"
        :items-per-page="10"
        class="table"
        :expanded="orders"
        show-expand
        ref="dTable"
        item-key="wellspring_order_id"
        :loading="loadingOrders"
      >
        <template v-slot:item.actions="{ item, index }">
          <router-link :to="`/bookings/edit/${item.id}`">
            <v-icon small class="mr-2">
              mdi-pencil
            </v-icon>
          </router-link>
          <v-icon
            v-if="item.can_delete == true"
            small
            @click="handleDelete(item, index)"
          >
            mdi-delete
          </v-icon>
        </template>
        <template v-slot:expanded-item="{ item, indexReservation }">
          <td
            v-if="item.reservations.length > 0"
            :colspan="ordersTableHeaders.length + 1"
            class="px-0 py-0"
          >
            <table width="100%" class="bg-gray">
              <thead>
                <tr>
                  <th class="text-center">Camp</th>
                  <th class="text-center">Team</th>
                  <th class="text-center">Campers</th>
                  <th class="text-center">Status</th>
                  <th class="text-center">Price</th>
                  <th class="text-center">Expiration Date</th>
                  <th class="text-center">Price After Discount</th>
                  <th class="text-center"></th>
                  <th class="text-center"></th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="reservation in item.reservations"
                  :key="reservation.id"
                >
                  <td class="text-center">{{ reservation.camp }}</td>
                  <td class="text-center">{{ reservation.team }}</td>
                  <td class="text-center">
                    <span v-if="reservation.camper != null">
                      <span v-html="reservation.camper.join('<br />')"></span>
                    </span>
                    <span v-else>---</span>
                  </td>
                  <td class="text-center">{{ reservation.status }}</td>

                  <td class="text-center">
                    {{ reservation.total_price + " " + reservation.currency }}
                  </td>
                  <td class="text-center">
                    {{ reservation.expires_at || "---" }}
                  </td>
                  <td class="text-center">
                    {{
                      reservation.price_after_discount +
                        " " +
                        reservation.currency
                    }}
                  </td>
                  <td v-if="reservation.deposit_amount" class="text-center">
                    {{
                      "Deposit amount : " +
                        reservation.deposit_amount +
                        " " +
                        reservation.currency
                    }}
                  </td>
                  <td class="text-center">
                    <v-btn
                      v-if="reservation.can_refund == true"
                      @click="refund(reservation)"
                      color="primary"
                      rounded
                      >Refund</v-btn
                    >
                  </td>
                  <td class="text-center">
                    <template v-if="item.type == 'ABR'">
                      <v-icon
                        class="mr-2"
                        @click="showAbroad(reservation)"
                        small
                      >
                        mdi-eye
                      </v-icon>
                      <v-icon
                        v-if="reservation.can_delete == true"
                        small
                        @click="
                          handleDeleteReservation(reservation, indexReservation)
                        "
                      >
                        mdi-delete
                      </v-icon>
                      <!-- <router-link
                        :to="`/bookings/reservations/${reservation.id}`"
                        v-if="reservation.can_edit == true"
                      >
                        <v-icon small class="mr-2">
                          mdi-pencil
                        </v-icon>
                      </router-link> -->
                    </template>
                    <template v-else>
                      <router-link
                        :to="`/bookings/reservations/${reservation.id}`"
                        v-if="reservation.can_edit == true"
                      >
                        <v-icon small class="mr-2">
                          mdi-pencil
                        </v-icon>
                      </router-link>
                      <v-icon
                        v-if="reservation.can_delete == true"
                        small
                        @click="
                          handleDeleteReservation(reservation, indexReservation)
                        "
                      >
                        mdi-delete
                      </v-icon>
                    </template>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </template>
      </v-data-table>
      <!-- pagination -->
      <div class="text-xs-center pt-2">
        <v-pagination
          v-if="orders.length > 0 && pagination.last_page > 1"
          v-model="pagination.current_page"
          :length="pagination.last_page"
          :total-visible="20"
          @input="handlePagination"
        ></v-pagination>
      </div>
      <!-- pagination -->
      <!-- Refund Dialog -->
      <v-dialog v-model="refundDialog" width="600px">
        <refund-modal
          @closeDialog="closeDialog"
          @printData="printData"
          @reloadData="reloadData"
          :refundDialog="refundDialog"
          :reservationObj="reservationObj"
          :reservationId="reservationId"
        />
      </v-dialog>
      <!-- Refund Dialog -->

      <!-- Abroad Camp -->
      <v-dialog v-model="abroad" width="1200px">
        <AbroadData
          :contacts="contacts"
          :camper="camper"
          :details="details"
          :camp_id="camp_id"
          :team_id="team_id"
          :passports="passports"
          :health_info="health_info"
          :abroadData="abroadData"
        ></AbroadData>
      </v-dialog>
      <!-- Abroad Camp -->

      <!-- Deposit Dialog -->
      <v-dialog v-model="depositDialog" width="600px">
        <v-card class="pa-5">
          <h2>Pay Deposit</h2>
          <hr class="my-5" />
          <section v-for="(item, index) in selected" :key="index">
            <v-row>
              <v-col cols="6">
                <p>Deposit</p>
              </v-col>
              <v-col cols="6">
                <p>{{ item.amount + " " + item.currency }}</p>
              </v-col>
            </v-row>
          </section>
          <hr class="mb-5" />
          <v-btn @click="payDeposit" rounded width="50%" color="success"
            >Approve</v-btn
          >
          <v-btn
            @click="depositDialog = false"
            rounded
            width="50%"
            outlined
            color="error"
            >Cancel</v-btn
          >
        </v-card>
      </v-dialog>
      <!-- Deposit Dialog -->
    </v-container>
    <printed-receipt :item="item" id="section-to-print"></printed-receipt>
  </main>
</template>

<script>
import TableHeaders from "@/helpers/TableHeaders";

import {
  IndexData,
  StoreData,
  DeleteData,
  IndexDataQuery,
  ShowData
} from "@/helpers/apiMethods";
import { isEqual } from "lodash";

export default {
  data() {
    return {
      orders: [],
      paymentCheck: [],
      DepositCheck: [],
      item: {},
      ordersTableHeaders: [
        {
          text: "Order Id",
          align: "center",
          sortable: false,
          value: "wellspring_order_id"
        },
        {
          text: "Date",
          align: "center",
          sortable: false,
          value: "order_date"
        },
        {
          text: "Payment Method",
          align: "center",
          sortable: false,
          value: "payment_method"
        },
        {
          text: "Status",
          align: "center",
          sortable: false,
          value: "status"
        },
        {
          text: "Parent Account",
          align: "center",
          sortable: false,
          value: "parent_account"
        },
        {
          text: "Mobile",
          align: "center",
          sortable: false,
          value: "mobile"
        },
        {
          text: "Account No",
          align: "center",
          sortable: false,
          value: "account_no"
        },
        {
          text: "Amount",
          align: "center",
          sortable: false,
          value: "amount"
        },
        { text: "Actions", value: "actions", align: "center", sortable: false },
        { text: "", value: "data-table-expand" }
      ],
      filter: {
        camp_id: "",
        wellspringid: "",
        month: "",
        year: "",
        status: ""
      },
      statuses: [
        { name: "Submitted", abbreviation: "S" },
        { name: "Approved", abbreviation: "A" },
        { name: "Approved by admin", abbreviation: "AM" },
        { name: "Deleted", abbreviation: "D" },
        { name: "Draft", abbreviation: "Dr" },
        { name: "Refunded", abbreviation: "R" },
        { name: "Expired", abbreviation: "X" }
      ],
      months: [
        { num: "01" },
        { num: "02" },
        { num: "03" },
        { num: "04" },
        { num: "05" },
        { num: "06" },
        { num: "07" },
        { num: "08" },
        { num: "09" },
        { num: "10" },
        { num: "11" },
        { num: "12" }
      ],
      yearsList: [
        { year: "2000" },
        { year: "2001" },
        { year: "2002" },
        { year: "2003" },
        { year: "2004" },
        { year: "2005" },
        { year: "2006" },
        { year: "2007" },
        { year: "2008" },
        { year: "2009" },
        { year: "2010" },
        { year: "2011" },
        { year: "2012" },
        { year: "2013" },
        { year: "2014" },
        { year: "2015" },
        { year: "2016" },
        { year: "2017" },
        { year: "2018" },
        { year: "2019" },
        { year: "2020" },
        { year: "2021" },
        { year: "2022" },
        { year: "2023" },
        { year: "2024" },
        { year: "2025" },
        { year: "2026" },
        { year: "2027" },
        { year: "2028" },
        { year: "2029" },
        { year: "2030" }
      ],
      reservationId: "",
      pagination: {},
      expanding: true,
      loadingOrders: false,
      expanded: [],
      camps: [],
      zero: 0,
      refundDialog: false,
      reservationObj: {},
      selected: [],
      singleSelect: false,
      queries: {},
      canPay: false,
      abroad: false,
      depositDialog: false,
      abroadData: {},
      contacts: {},
      details: {},
      camp_id: {},
      team_id: {},
      health_info: {},
      passports: [],
      camper: {}
    };
  },
  components: {
    RefundModal: () => import("./components/RefundModal"),
    AbroadData: () => import("./components/AbroadData"),
    PrintedReceipt: () =>
      import("@/views/bookings/reciepts/components/PrintedReceipt.vue"),
    InputFilter: () => import("@/views/accounts/components/InputFilter")
  },
  computed: {
    paymentBoolean() {
      if (this.paymentCheck.includes(false)) {
        return true;
      } else {
        return false;
      }
    },
    DepositBoolean() {
      if (this.DepositCheck.includes(false)) {
        return true;
      } else {
        return false;
      }
    }
  },
  created() {
    // this.indexBookings();
    this.indexCamps();
  },
  methods: {
    indexCamps() {
      IndexDataQuery({ reqName: "camps?a&pagination=all" })
        .then(res => {
          const { data } = res.data;
          this.camps = data;
        })
        .catch(() => {})
        .finally(() => {});
    },
    indexBookings(query) {
      this.loadingOrders = true;
      IndexData({ reqName: "orders", query })
        .then(res => {
          const { data, meta } = res.data;
          this.orders = data;
          this.loadingOrders = false;
          this.pagination = meta;
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.loadingOrders = false;
        });
    },
    handlePagination(page) {
      this.queries = { ...this.$route.query, page };
      if (!isEqual(this.queries, this.$route.query)) {
        this.$router.push({ query: this.queries });
      }
    },
    ordersHeaders() {
      const headersList = [
        "Order Id",
        "Date",
        "Payment Method",
        "Status",
        "Parent Account",
        "Mobile",
        "Account No",
        "Amount",
        "Actions"
      ];
      this.ordersTableHeaders = TableHeaders(headersList);
    },
    handleDelete({ id }, index) {
      this.popUp().then(value => {
        if (!value.dismiss) {
          DeleteData({
            reqName: `/orders/destroy`,
            id: id
          })
            .then(() => {
              // this.$delete(this.orders, index);
              this.orders.splice(index, 1);
            })
            .catch(() => {});
        }
      });
    },
    handleDeleteReservation({ id }) {
      this.popUp().then(value => {
        if (!value.dismiss) {
          DeleteData({
            reqName: `/reservations/destroy`,
            id: id
          })
            .then(() => {
              this.indexBookings(this.$route.query);
            })
            .catch(() => {});
        }
      });
    },
    refund(reservation) {
      this.refundDialog = true;
      this.reservationObj = reservation;
      this.reservationId = reservation.id;
    },
    closeDialog() {
      this.refundDialog = false;
    },
    printData(data) {
      this.item = data;
      this.$nextTick(() => {
        window.print(this.item);
      });
    },
    reloadData() {
      this.indexBookings(this.$route.query);
    },
    filterCamps(camp_id) {
      let routeQuery = { ...this.$route.query };
      this.$router.push({ query: { ...routeQuery, camp_id, page: 1 } });
    },
    filterMonths(month) {
      let routeQuery = { ...this.$route.query };
      this.$router.push({ query: { ...routeQuery, month, page: 1 } });
    },
    filterYears(year) {
      let routeQuery = { ...this.$route.query };
      this.$router.push({ query: { ...routeQuery, year, page: 1 } });
    },
    filterStatuses(status) {
      let routeQuery = { ...this.$route.query };
      this.$router.push({ query: { ...routeQuery, status, page: 1 } });
    },
    filterId(wellspringid) {
      let routeQuery = { ...this.$route.query };
      this.$router.push({ query: { ...routeQuery, wellspringid, page: 1 } });
    },
    clearSearchData(name) {
      let routeQuery = { ...this.$route.query };
      this.filter[name] = "";
      delete routeQuery[name];
      this.$router.push({ query: routeQuery });
    },
    payOrders() {
      this.$store.commit("SET_PAYMENT", this.selected);
      this.$router.push("/bookings/pay");
    },
    payDeposit() {
      const formData = new FormData();

      this.selected.forEach(formItem => {
        formData.append(`order_id[]`, formItem.id);
        formData.append(`parent_id[]`, formItem.parent_id);
      });
      this.popUp().then(value => {
        if (!value.dismiss) {
          StoreData({
            reqName: `pay-deposit`,
            data: formData
          })
            .then(() => {
              this.depositDialog = false;
              this.indexBookings();
              this.selected = [];
            })
            .catch(() => {})
            .finally(() => {});
        }
      });
    },
    showAbroad(reservation) {
      ShowData({
        reqName: `applications`,
        id: reservation.application_id
      })
        .then(res => {
          const { application } = res.data;
          console.log(application);
          this.abroadData = application;
          this.camper = application.camper;
          this.contacts = application.contacts;
          this.details = application.details;
          this.camp_id = application.camp_id;
          this.team_id = application.team_id;
          this.passports = application.passports;
          this.health_info = application.health_info;
        })
        .catch(() => {});
      this.abroad = true;
    }
  },
  watch: {
    selected: {
      handler(val) {
        this.paymentCheck = val.map(el => el.can_pay);
        this.DepositCheck = val.map(el => el.can_pay_deposit);
      },
      immediate: true
    },
    $route: {
      handler(route) {
        const { query } = route;
        // this.queries = query;
        this.pagination.current_page = query.page;
        if (query.camp_id) {
          this.filter.camp_id = Number(query.camp_id);
        }
        this.filter.month = query.month;
        this.filter.year = query.year;
        if (query.status) {
          this.filter.status = String(query.status);
        }
        if (query.wellspringid) {
          this.filter.wellspringid = String(query.wellspringid);
        }
        let decodedQuery = {};
        for (const key in query) {
          decodedQuery[key] = encodeURIComponent(query[key]);
        }
        this.indexBookings(decodedQuery);
      },
      immediate: true
    }
  }
};
</script>
